import React, { memo, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';

import { Box, Flex, Heading, Stack } from '@chakra-ui/layout';
import { FormHandles } from '@unform/core';
import {
  Button,
  Label,
  RadioInput,
  TextAreaInput,
  TextInput,
  Unform,
  AddObservation,
  CheckboxComp,
  DateInput,
} from 'components';
import { BodyProps } from 'constants/MultipleAcorddions';
import TPA from 'models/Forms/TPA';
import { ThirdPartyAssessmentCtx } from 'pages';
import { checkPermission } from 'utils/authentication';

import CommentedAnswer, { yo } from 'models/CommentedAnswer';
import { getCommonProps } from 'utils/CommonPropperties';
import { getAllClients } from 'services/client';
import { openNotification } from 'utils/notification';

const Item: React.FC<BodyProps> = ({ functionCallback, index, submit, completed }) => {
  const [isAble, setAble] = useState(false);
  const [clients, setClients] = useState<{ name: string; id: React.ReactText }[]>([]);
  const [contractor, setContractor] = useState<{ name: string; id: React.ReactText }[]>([]);
  const [clientContract] = contractor;
  const ctx = useContext(ThirdPartyAssessmentCtx);
  const [loading, setLoading] = useState(false);
  const isCheckedRef = useRef({
    reviewDate: ctx.isDetails ? !ctx.data.reviewDate : false,
    receiveDate: ctx.isDetails ? !ctx.data.receiveDate : false,
  });
  const formRef = useRef<FormHandles>(null);
  const [isChecked, setIsChecked] = useState(isCheckedRef.current);
  const [cc, setCc] = useState({
    contratante: '',
    contratado: '',
  });

  const cProps = useMemo(() => getCommonProps(ctx.isDetails), [ctx.isDetails]);

  const handleSubmit = useCallback(
    async (data: TPA) => {
      const { areaResponsable, companyName, contact, dpo, receiveDate, reviewDate } = data;
      setLoading(true);

      const formatDate = (dateString: any) => {
        const [day, month, year] = dateString?.split('/');

        return new Date(year, month - 1, day);
      };

      if (formatDate(receiveDate) > formatDate(reviewDate)) {
        openNotification(
          'A data de expiração não pode ser maior que a data de assinatura.',
          'warn',
        );
        setLoading(false);

        return;
      }

      if (submit) {
        const resp = await submit(
          { areaResponsable, companyName, contact, dpo, receiveDate, reviewDate },
          '3 - Teste Controlador-Operador',
        );
        if (resp) {
          functionCallback(index + 1);
        }
      } else {
        functionCallback(index + 1);
      }
      setLoading(false);
    },
    [submit, functionCallback, index],
  );

  useEffect(() => {
    if (checkPermission({ onlyAdmin: true })) {
      (async () => {
        const { data } = await getAllClients('');
        setClients(data);
        setContractor(clients?.filter(item => item.id === ctx.data.clientId && item));
      })();
    }
  }, [ctx.data.clientId]);

  const handleField = useCallback(
    (
      k1: 'jsonCompanyPosition' | 'jsonThirdPartyPosition',
      k2: keyof TPA['jsonCompanyPosition'],
      k3: keyof CommentedAnswer,
      e: React.ChangeEvent<HTMLInputElement> | yo,
    ) => {
      ctx.handlePayload(dt => {
        const data = {
          ...dt,
        };
        if (k3 === 'comments' && typeof e !== 'string') data[k1][k2][k3] = e.target.value;
        else if (typeof e === 'string') data[k1][k2][k3] = e;
        return data;
      });
    },
    [ctx.handlePayload],
  );

  useEffect(() => {
    if (ctx.client?.name) {
      formRef.current?.setFieldValue('companyName', ctx.client?.name);
      setCc(c => ({ ...c, contratante: ctx.client?.name || '' }));
    }
  }, [ctx.client?.name]);

  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Box>
        <Heading mb="1.5rem" as="div" color="brand.tertiary" fontSize="16px">
          Preencher Descrição do Contrato
        </Heading>
      </Box>
      <Unform
        formRef={formRef}
        initialData={ctx.data}
        onSubmit={handleSubmit}
        // validationSchema={validation}
      >
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            <Box>
              <TextInput
                label="Objeto do Contrato"
                placeholder="Digite aqui"
                name="areaResponsable"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextInput
                label="Contratante"
                placeholder="Digite aqui"
                name="companyName"
                {...cProps}
                value={clientContract?.name}
                disabled
                isDisabled
              />
            </Box>
            <Box>
              <TextInput
                onChange={e => setCc(c => ({ ...c, contratado: e.target.value }))}
                label="Contratado"
                placeholder="Digite aqui"
                name="contact"
                // {...cProps}
              />
            </Box>

            <Box>
              <DateInput
                name="receiveDate"
                leftIcon="calendar"
                label="Data de Assinatura"
                disabled={isChecked.receiveDate}
              />

              <Box pl="14px">
                <CheckboxComp
                  onChange={(e: any) => {
                    isCheckedRef.current = {
                      ...isCheckedRef.current,
                      receiveDate: e.target.checked,
                    };
                    formRef.current?.clearField('receiveDate');
                    setIsChecked(isCheckedRef.current);
                  }}
                  isChecked={isCheckedRef.current.receiveDate}
                >
                  Contrato não assinado
                </CheckboxComp>
              </Box>
            </Box>
            <Box>
              <DateInput
                name="reviewDate"
                leftIcon="calendar"
                label="Data de Expiração"
                disabled={isChecked.reviewDate}
              />

              <Box pl="14px">
                <CheckboxComp
                  onChange={(e: any) => {
                    isCheckedRef.current = {
                      ...isCheckedRef.current,
                      reviewDate: e.target.checked,
                    };
                    formRef.current?.clearField('reviewDate');
                    setIsChecked(isCheckedRef.current);
                    setAble(!isAble);
                  }}
                  isChecked={isCheckedRef.current.reviewDate}

                  // {...cProps}
                >
                  Prazo Indeterminado
                </CheckboxComp>
              </Box>
            </Box>
            <Box mb="32px">
              <TextAreaInput
                mt="8px"
                label="Lista de Dados Pessoais Envolvidos na Contratação"
                placeholder="Digite aqui"
                name="dpo"
                rows={5}
                // {...cProps}
              />
            </Box>
            <Heading mb="1.5rem" as="div" color="brand.tertiary" fontSize="16px">
              Preencha aqui informações sobre a empresa {cc.contratante}
            </Heading>
            <Box mb="24px">
              <Label>Autonomamente decide coletar ou tratar os dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="companyPos_collectData"
                  label={ctx.data.jsonCompanyPosition?.collectData.answer === 'yes' ? 'Sim' : 'Não'}
                  value={ctx.data.jsonCompanyPosition?.collectData.answer}
                  onChange={handleField.bind(null, 'jsonCompanyPosition', 'collectData', 'answer')}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.collectData.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'collectData',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Autonomamente decide as finalidades ou o resultado do tratamento de dados pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="companyPos_purposesResult"
                  label={
                    ctx.data.jsonCompanyPosition?.purposesResult.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.purposesResult.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'purposesResult',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.purposesResult.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'purposesResult',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente decide quais dados pessoais devem ser coletados?</Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_decidePersonalDataCollected"
                  // {...cProps}
                  label={
                    ctx.data.jsonCompanyPosition?.decidePersonalDataCollected.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.decidePersonalDataCollected.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'decidePersonalDataCollected',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.decidePersonalDataCollected.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'decidePersonalDataCollected',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente decide de que titulares coletar os dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="companyPos_holdersCollectDataFrom"
                  label={
                    ctx.data.jsonCompanyPosition?.holdersCollectDataFrom.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.holdersCollectDataFrom.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'holdersCollectDataFrom',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.holdersCollectDataFrom.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'holdersCollectDataFrom',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Obtém ganho e/ou benefício direto com o tratamento dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="companyPos_benefitDirectly"
                  label={
                    ctx.data.jsonCompanyPosition?.benefitDirectly.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.benefitDirectly.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'benefitDirectly',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.benefitDirectly.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'benefitDirectly',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Trata os dados pessoais no contexto de um contrato direto com o titular dos dados
                pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="companyPos_handlePersonalDataContext"
                  label={
                    ctx.data.jsonCompanyPosition?.handlePersonalDataContext.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.handlePersonalDataContext.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'handlePersonalDataContext',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.handlePersonalDataContext.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'handlePersonalDataContext',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>É empregador dos titulares dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="companyPos_employerDataHolders"
                  label={
                    ctx.data.jsonCompanyPosition?.employerDataHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.employerDataHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'employerDataHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.employerDataHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'employerDataHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Toma decisões que impactam os titulares dos dados pessoais no contexto do
                tratamento?
              </Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="companyPos_decisionImpactTheHolders"
                  label={
                    ctx.data.jsonCompanyPosition?.decisionImpactTheHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.decisionImpactTheHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'decisionImpactTheHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.decisionImpactTheHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'decisionImpactTheHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Emite opiniões profissionais no contexto do tratamento dos dados pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="companyPos_professionalOpinions"
                  label={
                    ctx.data.jsonCompanyPosition?.professionalOpinions.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.professionalOpinions.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'professionalOpinions',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.professionalOpinions.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'professionalOpinions',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Possui relacionamento direto com os titulares dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="companyPos_directRelationshipTheHolders"
                  label={
                    ctx.data.jsonCompanyPosition?.directRelationshipTheHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.directRelationshipTheHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'directRelationshipTheHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.directRelationshipTheHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'directRelationshipTheHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente determina como os dados pessoais serão tratados?</Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="companyPos_determinesHowDatatreated"
                  label={
                    ctx.data.jsonCompanyPosition?.determinesHowDatatreated.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.determinesHowDatatreated.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'determinesHowDatatreated',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.determinesHowDatatreated.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'determinesHowDatatreated',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                É responsável pelo engajamento de outras empresas para tratamento dos dados pessoais
                em seu nome?
              </Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="companyPos_engagingOtherCompanies"
                  label={
                    ctx.data.jsonCompanyPosition?.engagingOtherCompanies.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.engagingOtherCompanies.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'engagingOtherCompanies',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.engagingOtherCompanies.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'engagingOtherCompanies',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Heading mb="1.5rem" as="div" color="brand.tertiary" fontSize="16px">
              Preencha aqui informações sobre a outra parte {cc.contratado}
            </Heading>
            <Box mb="24px">
              <Label>Autonomamente decide coletar ou tratar os dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="TPPos_collectData"
                  label={
                    ctx.data.jsonThirdPartyPosition?.collectData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.collectData.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'collectData',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.collectData.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'collectData',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Autonomamente decide as finalidades ou o resultado do tratamento de dados pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  // {...cProps}
                  name="TPPos_purposesResult"
                  label={
                    ctx.data.jsonThirdPartyPosition?.purposesResult.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.purposesResult.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'purposesResult',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.purposesResult.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'purposesResult',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente decide quais dados pessoais devem ser coletados?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_decidePersonalDataCollected"
                  // {...cProps}
                  label={
                    ctx.data.jsonThirdPartyPosition?.decidePersonalDataCollected.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.decidePersonalDataCollected.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'decidePersonalDataCollected',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.decidePersonalDataCollected.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'decidePersonalDataCollected',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente decide de que titulares coletar os dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_holdersCollectDataFrom"
                  // {...cProps}
                  label={
                    ctx.data.jsonThirdPartyPosition?.holdersCollectDataFrom.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.holdersCollectDataFrom.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'holdersCollectDataFrom',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.holdersCollectDataFrom.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'holdersCollectDataFrom',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Obtém ganho e/ou benefício direto com o tratamento dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_benefitDirectly"
                  // {...cProps}
                  label={
                    ctx.data.jsonThirdPartyPosition?.benefitDirectly.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.benefitDirectly.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'benefitDirectly',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.benefitDirectly.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'benefitDirectly',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Trata os dados pessoais no contexto de um contrato direto com o titular dos dados
                pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_handlePersonalDataContext"
                  // {...cProps}
                  label={
                    ctx.data.jsonThirdPartyPosition?.handlePersonalDataContext.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.handlePersonalDataContext.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'handlePersonalDataContext',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.handlePersonalDataContext.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'handlePersonalDataContext',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>É empregador dos titulares dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_employerDataHolders"
                  // {...cProps}
                  label={
                    ctx.data.jsonThirdPartyPosition?.employerDataHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.employerDataHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'employerDataHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.employerDataHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'employerDataHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Toma decisões que impactam os titulares dos dados pessoais no contexto do
                tratamento?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_decisionImpactTheHolders"
                  // {...cProps}
                  label={
                    ctx.data.jsonThirdPartyPosition?.decisionImpactTheHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.decisionImpactTheHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'decisionImpactTheHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.decisionImpactTheHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'decisionImpactTheHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Emite opiniões profissionais no contexto do tratamento dos dados pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_professionalOpinions"
                  // {...cProps}
                  label={
                    ctx.data.jsonThirdPartyPosition?.professionalOpinions.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.professionalOpinions.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'professionalOpinions',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.professionalOpinions.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'professionalOpinions',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Possui relacionamento direto com os titulares dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_directRelationshipTheHolders"
                  // {...cProps}
                  label={
                    ctx.data.jsonThirdPartyPosition?.directRelationshipTheHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.directRelationshipTheHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'directRelationshipTheHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.directRelationshipTheHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'directRelationshipTheHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente determina como os dados pessoais serão tratados?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_determinesHowDatatreated"
                  // {...cProps}
                  label={
                    ctx.data.jsonThirdPartyPosition?.determinesHowDatatreated.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.determinesHowDatatreated.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'determinesHowDatatreated',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.determinesHowDatatreated.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'determinesHowDatatreated',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                É responsável pelo engajamento de outras empresas para tratamento dos dados pessoais
                em seu nome?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_engagingOtherCompanies"
                  // {...cProps}
                  label={
                    ctx.data.jsonThirdPartyPosition?.engagingOtherCompanies.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.engagingOtherCompanies.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'engagingOtherCompanies',
                    'answer',
                  )}
                />
                <AddObservation
                  // isDetail={ctx.isDetails}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.engagingOtherCompanies.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'engagingOtherCompanies',
                    'comments',
                  )}
                />
              </Box>
            </Box>

            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            <Box>
              <TextInput
                label="Objeto do Contrato"
                placeholder="Digite aqui"
                name="areaResponsable"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <TextInput
                label="Contratante"
                placeholder="Digite aqui"
                name="companyName"
                {...cProps}
                defaultValue={ctx?.client?.name || ''}
                disabled
                isDisabled
              />
            </Box>
            <Box>
              <TextInput
                onChange={e => setCc(c => ({ ...c, contratado: e.target.value }))}
                label="Contratado"
                placeholder="Digite aqui"
                name="contact"
                isDisabled={completed}
              />
            </Box>
            <Box>
              <DateInput
                name="receiveDate"
                leftIcon="calendar"
                label="Data de Assinatura"
                disabled={isChecked.receiveDate || completed}
                // isDisabled={isChecked.receiveDate || ctx.isDetails}
              />
              <Box pl="14px" mt="14px">
                <CheckboxComp
                  onChange={(e: any) => {
                    isCheckedRef.current = {
                      ...isCheckedRef.current,
                      receiveDate: e.target.checked,
                    };
                    formRef.current?.clearField('receiveDate');
                    setIsChecked(isCheckedRef.current);
                  }}
                  isChecked={
                    ctx.isDetails && completed
                      ? !ctx.data.receiveDate
                      : isCheckedRef.current.receiveDate
                  }
                  // {...cProps}
                >
                  Contrato não assinado
                </CheckboxComp>
              </Box>
            </Box>
            <Box>
              <DateInput
                name="reviewDate"
                leftIcon="calendar"
                label="Data de Expiração"
                {...cProps}
                disabled={isChecked.reviewDate || completed}
                // isDisabled={isChecked.reviewDate || ctx.isDetails}
              />
              <Box pl="14px" mt="14px">
                <CheckboxComp
                  onChange={(e: any) => {
                    isCheckedRef.current = {
                      ...isCheckedRef.current,
                      reviewDate: e.target.checked,
                    };
                    formRef.current?.clearField('reviewDate');
                    setIsChecked(isCheckedRef.current);
                  }}
                  isChecked={
                    ctx.isDetails && completed
                      ? !ctx.data.reviewDate
                      : isCheckedRef.current.reviewDate
                  }
                  // {...cProps}
                >
                  Prazo Indeterminado
                </CheckboxComp>
              </Box>
            </Box>
            <Box mb="32px">
              <TextAreaInput
                mt="8px"
                label="Lista de Dados Pessoais Envolvidos na Contratação"
                placeholder="Digite aqui"
                name="dpo"
                rows={5}
                isDisabled={completed}
              />
            </Box>
            <Heading mb="1.5rem" as="div" color="brand.tertiary" fontSize="16px">
              Preencha aqui informações sobre a empresa {cc.contratante}
            </Heading>
            <Box mb="24px">
              <Label>Autonomamente decide coletar ou tratar os dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_collectData"
                  isDisabled={completed}
                  label={ctx.data.jsonCompanyPosition?.collectData.answer === 'yes' ? 'Sim' : 'Não'}
                  value={ctx.data.jsonCompanyPosition?.collectData.answer}
                  onChange={handleField.bind(null, 'jsonCompanyPosition', 'collectData', 'answer')}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.collectData.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'collectData',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Autonomamente decide as finalidades ou o resultado do tratamento de dados pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_purposesResult"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonCompanyPosition?.purposesResult.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.purposesResult.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'purposesResult',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.purposesResult.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'purposesResult',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente decide quais dados pessoais devem ser coletados?</Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_decidePersonalDataCollected"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonCompanyPosition?.decidePersonalDataCollected.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.decidePersonalDataCollected.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'decidePersonalDataCollected',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.decidePersonalDataCollected.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'decidePersonalDataCollected',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente decide de que titulares coletar os dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_holdersCollectDataFrom"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonCompanyPosition?.holdersCollectDataFrom.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.holdersCollectDataFrom.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'holdersCollectDataFrom',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.holdersCollectDataFrom.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'holdersCollectDataFrom',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Obtém ganho e/ou benefício direto com o tratamento dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_benefitDirectly"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonCompanyPosition?.benefitDirectly.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.benefitDirectly.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'benefitDirectly',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.benefitDirectly.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'benefitDirectly',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Trata os dados pessoais no contexto de um contrato direto com o titular dos dados
                pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_handlePersonalDataContext"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonCompanyPosition?.handlePersonalDataContext.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.handlePersonalDataContext.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'handlePersonalDataContext',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.handlePersonalDataContext.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'handlePersonalDataContext',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>É empregador dos titulares dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_employerDataHolders"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonCompanyPosition?.employerDataHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.employerDataHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'employerDataHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.employerDataHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'employerDataHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Toma decisões que impactam os titulares dos dados pessoais no contexto do
                tratamento?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_decisionImpactTheHolders"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonCompanyPosition?.decisionImpactTheHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.decisionImpactTheHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'decisionImpactTheHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.decisionImpactTheHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'decisionImpactTheHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Emite opiniões profissionais no contexto do tratamento dos dados pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_professionalOpinions"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonCompanyPosition?.professionalOpinions.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.professionalOpinions.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'professionalOpinions',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.professionalOpinions.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'professionalOpinions',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Possui relacionamento direto com os titulares dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_directRelationshipTheHolders"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonCompanyPosition?.directRelationshipTheHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.directRelationshipTheHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'directRelationshipTheHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.directRelationshipTheHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'directRelationshipTheHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente determina como os dados pessoais serão tratados?</Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_determinesHowDatatreated"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonCompanyPosition?.determinesHowDatatreated.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.determinesHowDatatreated.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'determinesHowDatatreated',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.determinesHowDatatreated.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'determinesHowDatatreated',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                É responsável pelo engajamento de outras empresas para tratamento dos dados pessoais
                em seu nome?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="companyPos_engagingOtherCompanies"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonCompanyPosition?.engagingOtherCompanies.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonCompanyPosition?.engagingOtherCompanies.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'engagingOtherCompanies',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonCompanyPosition.engagingOtherCompanies.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonCompanyPosition',
                    'engagingOtherCompanies',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Heading mb="1.5rem" as="div" color="brand.tertiary" fontSize="16px">
              Preencha aqui informações sobre a outra parte {cc.contratado}
            </Heading>
            <Box mb="24px">
              <Label>Autonomamente decide coletar ou tratar os dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_collectData"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.collectData.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.collectData.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'collectData',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.collectData.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'collectData',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Autonomamente decide as finalidades ou o resultado do tratamento de dados pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_purposesResult"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.purposesResult.answer === 'yes' ? 'Sim' : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.purposesResult.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'purposesResult',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.purposesResult.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'purposesResult',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente decide quais dados pessoais devem ser coletados?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_decidePersonalDataCollected"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.decidePersonalDataCollected.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.decidePersonalDataCollected.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'decidePersonalDataCollected',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.decidePersonalDataCollected.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'decidePersonalDataCollected',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente decide de que titulares coletar os dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_holdersCollectDataFrom"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.holdersCollectDataFrom.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.holdersCollectDataFrom.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'holdersCollectDataFrom',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.holdersCollectDataFrom.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'holdersCollectDataFrom',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Obtém ganho e/ou benefício direto com o tratamento dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_benefitDirectly"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.benefitDirectly.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.benefitDirectly.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'benefitDirectly',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.benefitDirectly.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'benefitDirectly',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Trata os dados pessoais no contexto de um contrato direto com o titular dos dados
                pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_handlePersonalDataContext"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.handlePersonalDataContext.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.handlePersonalDataContext.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'handlePersonalDataContext',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.handlePersonalDataContext.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'handlePersonalDataContext',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>É empregador dos titulares dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_employerDataHolders"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.employerDataHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.employerDataHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'employerDataHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.employerDataHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'employerDataHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Toma decisões que impactam os titulares dos dados pessoais no contexto do
                tratamento?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_decisionImpactTheHolders"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.decisionImpactTheHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.decisionImpactTheHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'decisionImpactTheHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.decisionImpactTheHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'decisionImpactTheHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                Emite opiniões profissionais no contexto do tratamento dos dados pessoais?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_professionalOpinions"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.professionalOpinions.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.professionalOpinions.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'professionalOpinions',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.professionalOpinions.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'professionalOpinions',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Possui relacionamento direto com os titulares dos dados pessoais?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_directRelationshipTheHolders"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.directRelationshipTheHolders.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.directRelationshipTheHolders.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'directRelationshipTheHolders',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.directRelationshipTheHolders.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'directRelationshipTheHolders',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>Autonomamente determina como os dados pessoais serão tratados?</Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_determinesHowDatatreated"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.determinesHowDatatreated.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.determinesHowDatatreated.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'determinesHowDatatreated',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.determinesHowDatatreated.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'determinesHowDatatreated',
                    'comments',
                  )}
                />
              </Box>
            </Box>
            <Box mb="24px">
              <Label>
                É responsável pelo engajamento de outras empresas para tratamento dos dados pessoais
                em seu nome?
              </Label>
              <Box mt="8px">
                <RadioInput
                  name="TPPos_engagingOtherCompanies"
                  isDisabled={completed}
                  label={
                    ctx.data.jsonThirdPartyPosition?.engagingOtherCompanies.answer === 'yes'
                      ? 'Sim'
                      : 'Não'
                  }
                  value={ctx.data.jsonThirdPartyPosition?.engagingOtherCompanies.answer}
                  onChange={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'engagingOtherCompanies',
                    'answer',
                  )}
                />
                <AddObservation
                  isDetail={completed}
                  placeholder="Observações"
                  obsValue={ctx.data.jsonThirdPartyPosition.engagingOtherCompanies.comments}
                  onChangeEvent={handleField.bind(
                    null,
                    'jsonThirdPartyPosition',
                    'engagingOtherCompanies',
                    'comments',
                  )}
                />
              </Box>
            </Box>

            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button>
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};

export const OperatorControllerTest = memo(Item);
